__turbopack_context__.v({
  "actions": "room-agents-module__CSiETW__actions",
  "agent": "room-agents-module__CSiETW__agent",
  "agentBadge": "room-agents-module__CSiETW__agentBadge",
  "agents": "room-agents-module__CSiETW__agents",
  "approvalMember": "room-agents-module__CSiETW__approvalMember",
  "artifacts": "room-agents-module__CSiETW__artifacts",
  "availability": "room-agents-module__CSiETW__availability",
  "avatar": "room-agents-module__CSiETW__avatar",
  "checkbox": "room-agents-module__CSiETW__checkbox",
  "compactStatus": "room-agents-module__CSiETW__compactStatus",
  "confirmation": "room-agents-module__CSiETW__confirmation",
  "connection": "room-agents-module__CSiETW__connection",
  "context": "room-agents-module__CSiETW__context",
  "disclose": "room-agents-module__CSiETW__disclose",
  "eventMark": "room-agents-module__CSiETW__eventMark",
  "events": "room-agents-module__CSiETW__events",
  "feedback": "room-agents-module__CSiETW__feedback",
  "files": "room-agents-module__CSiETW__files",
  "form": "room-agents-module__CSiETW__form",
  "heading": "room-agents-module__CSiETW__heading",
  "hint": "room-agents-module__CSiETW__hint",
  "image": "room-agents-module__CSiETW__image",
  "job": "room-agents-module__CSiETW__job",
  "jobBody": "room-agents-module__CSiETW__jobBody",
  "jobStatus": "room-agents-module__CSiETW__jobStatus",
  "jobTitle": "room-agents-module__CSiETW__jobTitle",
  "lastSeen": "room-agents-module__CSiETW__lastSeen",
  "latest": "room-agents-module__CSiETW__latest",
  "management": "room-agents-module__CSiETW__management",
  "preview": "room-agents-module__CSiETW__preview",
  "primary": "room-agents-module__CSiETW__primary",
  "readOnlyBanner": "room-agents-module__CSiETW__readOnlyBanner",
  "request": "room-agents-module__CSiETW__request",
  "result": "room-agents-module__CSiETW__result",
  "revisions": "room-agents-module__CSiETW__revisions",
  "roster": "room-agents-module__CSiETW__roster",
  "srOnly": "room-agents-module__CSiETW__srOnly",
  "toolbar": "room-agents-module__CSiETW__toolbar",
  "warning": "room-agents-module__CSiETW__warning",
  "workspace": "room-agents-module__CSiETW__workspace",
});
